export default __webpack_public_path__ + "static/media/SnehadeepDP.acc067cf.jpeg";